import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = new EncryptStorage('secret-key-value', {
    prefix: '@Khetivalah',
    storageType: 'localStorage',
    encAlgorithm: 'AES'
});